import {
  AdoptionReportPayload,
  Ratio,
} from "../../../../../services/adoptionReports/adoptionReports.types";

/** SCRUM-1557: `null` en el snapshot es «Dato no disponible», nunca 0. */
export const NOT_AVAILABLE = "Dato no disponible";

export const pct = (value: number | null | undefined): string =>
  value === null || value === undefined ? "—" : `${value}%`;

export const num = (value: number | null | undefined, digits = 1): string =>
  value === null || value === undefined ? "—" : value.toFixed(digits);

/** Semanas promedio: `9` en vez de `9.0`, `8.6` si hay decimales. */
export const weeksNum = (value: number | null | undefined): string =>
  value === null || value === undefined
    ? "—"
    : Number.isInteger(value)
    ? String(value)
    : value.toFixed(1);

export const ratioText = (r: Ratio | null | undefined): string =>
  r ? `${r.numerator}/${r.denominator}` : "—";

export const ratioWithPct = (r: Ratio | null | undefined): string =>
  r ? `${r.numerator}/${r.denominator}  (${pct(r.percentage)})` : "—";

const SHORT_MONTHS = [
  "ene",
  "feb",
  "mar",
  "abr",
  "may",
  "jun",
  "jul",
  "ago",
  "sep",
  "oct",
  "nov",
  "dic",
];

/** `2026-09-01` → `1 sep`. */
export const shortDate = (day: string): string =>
  `${Number(day.slice(8, 10))} ${SHORT_MONTHS[Number(day.slice(5, 7)) - 1]}`;

/** `Sep–Oct 2026` para el encabezado. */
export const periodBadge = (payload: AdoptionReportPayload): string => {
  const first = payload.months[0]?.label ?? "";
  const last = payload.months[payload.months.length - 1]?.label ?? "";
  const cap = (s: string) => s.slice(0, 3);
  const year = payload.period.to.slice(0, 4);
  return first === last ? `${first} ${year}` : `${cap(first)}–${cap(last)} ${year}`;
};

/** `septiembre y octubre` para el título de portada. */
export const monthsTitle = (payload: AdoptionReportPayload): string => {
  const labels = payload.months.map((m) => m.label.toLowerCase());
  if (labels.length <= 1) return labels[0] ?? "";
  return `${labels.slice(0, -1).join(", ")} y ${labels[labels.length - 1]}`;
};

export const cutoffText = (payload: AdoptionReportPayload): string => {
  const date = new Date(payload.data_cutoff_at);
  return date.toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "America/Mexico_City",
  });
};

export const levelName = (payload: AdoptionReportPayload): string =>
  payload.level === "KINDER" ? "Kinder" : "Primaria";

export const truncate = (text: string, max: number): string =>
  text.length <= max ? text : `${text.slice(0, max - 1).trimEnd()}…`;

/** Nombre de archivo del PDF: `Emmi-Reporte-Primaria-Colegio-X-sep-oct-2026-v2.pdf`. */
export const pdfFileName = (payload: AdoptionReportPayload): string => {
  const school = payload.school.name
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^A-Za-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  const months = payload.months.map((m) => m.label.slice(0, 3).toLowerCase()).join("-");
  return `Emmi-Reporte-${levelName(payload)}-${school}-${months}-${payload.period.to.slice(0, 4)}-v${payload.report_version}.pdf`;
};
